module.exports = __webpack_public_path__ + "static/media/buy.31be58ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/buy.png
// module id = 1097
// module chunks = 0